import { render } from "./edit.vue?vue&type=template&id=b15536ce"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/profile/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b15536ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b15536ce', __exports__)) {
    console.log('reload')
    api.reload('b15536ce', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=b15536ce", () => {
    console.log('re-render')
    api.rerender('b15536ce', render)
  })

}


export default __exports__